import { addEditData, getData, removeData } from '../generic';
import { cAPI } from '../../../utils/cAPI';

export const getMediaFolderContent = searchConfig => dispatch => getData(dispatch, cAPI.APGetMediaFolderContent, searchConfig, 'mediaLibrary');
export const deleteMediaFiles = formData => dispatch => removeData(dispatch, cAPI.APDeleteMediaFiles, formData, 'mediaLibrary');

export const getMediaFile = searchConfig => dispatch => getData(dispatch, cAPI.APGetMediaFile, searchConfig, 'mediaLibraryFileEdit', false);
export const getSearchMediaFiles = id => dispatch => getData(dispatch, cAPI.APGetSearchMediaFiles, id, 'mediaLibraryFile');
export const updateMediaFiles = formData => dispatch => addEditData(dispatch, cAPI.APUpdateMediaFiles, formData, 'mediaLibraryFileEdit');